// extracted by mini-css-extract-plugin
export default {"dateRange":"InvoicesList_dateRange__uIY0w","filters":"InvoicesList_filters__g5FpG"};